module.exports = __webpack_public_path__ + "static/logo-pink.3a21b87b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/logo-pink.svg
// module id = 144
// module chunks = 35783957827783 114276838955818